module.exports = __webpack_public_path__ + "static/img/Taylor_Walker_desktop.0eaadaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor_Walker_desktop.jpg
// module id = I7gS
// module chunks = 0